<template>
    <div class="row">
        <div class="col-md-12" style="border-right: 1px solid #eaeaea">
            <button
                class="btn btn-success btn-xs btn-block"
                type="button"
                @click="$bvModal.show('create-group')"
            >
                <i class="mdi mdi-plus"></i>
                Criar Grupo
            </button>
            <input
                type="text"
                class="form-control"
                v-model="search"
                placeholder="Pesquisar..."
            />
            <load v-if="load" mode="table" />

            <ul class="contacts-list" v-else>
                <li
                    v-for="group in filterGroups"
                    :key="group.id"
                    @click="selectGroup(group)"
                    class="user-list py-2 px-2 d-block"
                    :class="{ selected: group == selected }"
                >
                    <div class="w-100">
                        <div
                            class="contact d-flex flex-row justify-content-between"
                        >
                            <b class="name">
                                <i
                                    v-if="group.id == selected.id"
                                    class="mdi mdi-chevron-right-circle text-primary"
                                ></i
                                >{{ group.name }}</b
                            >
                            <span>
                                <span class="unread mx-2" v-if="group.unread">
                                    {{ group.unread }}
                                </span>
                                <span v-for="user in userOnline" :key="user.id">
                                    <span
                                        v-if="
                                            user.unidade_id ==
                                                group.unidade_id ||
                                            user.unidadeID == group.unidade_id
                                        "
                                        class="availability-status online"
                                    >
                                        <i
                                            class="fa fa-circle"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </span>

                                <i
                                    v-if="group.access"
                                    @click="$bvModal.show('detail-group')"
                                    class="mdi mdi-dots-vertical"
                                ></i>
                                <i v-else class="mdi mdi-lock text-danger"></i>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ModalCreateGroup :contacts="contacts" @create="$emit('reload')" />
        <ModalDetailGroup :item="selected" />
    </div>
</template>

<script>
import ModalCreateGroup from "./includes/ModalCreateGroup";
import ModalDetailGroup from "./includes/ModalDetailGroup";
export default {
    components: { ModalCreateGroup, ModalDetailGroup },
    props: {
        contacts: {
            type: Array,
            default: [],
        },
        groups: {
            type: Array,
            default: [],
        },
        load: { type: Boolean, default: true },
    },
    data() {
        return {
            selected: this.groups.length ? this.groups[0] : null,
            search: "",
            loadContact: true,
        };
    },
    methods: {
        selectGroup(group) {
            if (group.access) {
                this.selected = group;

                this.$emit("selected", group);
            }
        },
    },
    mounted() {
        var group_save = localStorage.getItem("chat-selected-group");

        if (group_save) {
            this.selected = JSON.parse(group_save);
        }
    },
    computed: {
        sortedGroups() {
            return _.sortBy(this.groups, [
                (group) => {
                    if (group) {
                        if (group.id == this.selected.id) {
                            return Infinity;
                        }

                        return group.unread;
                    }
                },
            ]).reverse();
        },
        filterGroups: function () {
            return this.sortedGroups.filter((group) => {
                return group.name
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
            });
        },
        userOnline() {
            return this.$store.state.users;
        },
    },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
    background-color: #f4f4f4;
}
::-webkit-scrollbar {
    width: 5px;
    background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
    background: #979797;
    border-radius: 25em;
}
.unread {
    background: #fb8994;
    color: #fff;
    right: 11px;
    min-width: 20px;
    /* top: 20px; */
    align-items: center;
    line-height: 20px;
    font-size: 12px;
    padding: 0 4px;
    /* float: right; */
    z-index: 1010;
    /* position: absolute; */
    text-align: center;
    border-radius: 10px;
}
.contacts-list {
    flex: 2;
    height: 58vh;
    overflow: auto;
    list-style: none;
    padding: 0;
    margin: 0;
}
.contact:hover {
    color: #0d5a9e;
}
.availability-status {
    font-size: 8px;
}
.availability-status.online {
    color: #1bcfb4;
}
.availability-status .offline {
    background: #ccc;
}
.user-list {
    /* min-height: 50px; */
    border-bottom: 1px solid #eaeaea;
}
.user-list:hover {
    cursor: pointer;
    background: #f4f4f4;
}
</style>
